





































































import { SurveyStatus, SurveyType } from "@/interfaces";
import { AuthModule } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManagementDestinationAccess extends Vue {
  @AuthModule.bindings.Getter
  statusBySection!: (section: SurveyType) => SurveyStatus;

  loading = false;

  menu: any = [];

  mounted() {
    this.menu = [
      {
        title: "Analisi",
        subtitle: "",
        to: this.analysisLink,
      },
      {
        title: "Strategie",
        subtitle: "",
        to: "/accessibility-strategies",
      },
      {
        title: "Iniziative",
        subtitle: "",
        to: "/accessibility-initiative",
      },
    ];
  }

  onSurveyTypeClick(to: string) {
    this.$router.push(to).catch(error => console.log(error));
  }

  get analysisLink() {
    const find = this.statusBySection(SurveyType.ANALYSIS_ACCESSIBILITY);

    if (find && find.id) {
      return `survey/${SurveyType.ANALYSIS_ACCESSIBILITY}/${find.id}`;
    }

    return `survey/${SurveyType.ANALYSIS_ACCESSIBILITY}`;
  }
}
